var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6667 2V12C15.6667 13.1 14.7667 14 13.6667 14H2.66675V6C2.66675 3.79 4.45675 2 6.66675 2H15.6667Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6667 14V17C22.6667 18.66 21.3267 20 19.6667 20H18.6667C18.6667 18.9 17.7667 18 16.6667 18C15.5667 18 14.6667 18.9 14.6667 20H10.6667C10.6667 18.9 9.76675 18 8.66675 18C7.56675 18 6.66675 18.9 6.66675 20H5.66675C4.00675 20 2.66675 18.66 2.66675 17V14H13.6667C14.7667 14 15.6667 13.1 15.6667 12V5H17.5067C18.2267 5 18.8867 5.39001 19.2467 6.01001L20.9568 9H19.6667C19.1167 9 18.6667 9.45 18.6667 10V13C18.6667 13.55 19.1167 14 19.6667 14H22.6667Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.66675 22C9.77132 22 10.6667 21.1046 10.6667 20C10.6667 18.8954 9.77132 18 8.66675 18C7.56218 18 6.66675 18.8954 6.66675 20C6.66675 21.1046 7.56218 22 8.66675 22Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.6667 22C17.7713 22 18.6667 21.1046 18.6667 20C18.6667 18.8954 17.7713 18 16.6667 18C15.5622 18 14.6667 18.8954 14.6667 20C14.6667 21.1046 15.5622 22 16.6667 22Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.6667 12V14H19.6667C19.1167 14 18.6667 13.55 18.6667 13V10C18.6667 9.45 19.1167 9 19.6667 9H20.9568L22.6667 12Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalService);
export default __webpack_public_path__ + "static/media/ProfessionalService.972936990bf8a0dc1a4ca0c7eb094fd3.svg";
export { ForwardRef as ReactComponent };